import { EntityMetadataMap } from '@ngrx/data';

const entityMetadata: EntityMetadataMap = {
  Announcement: {}, // just an example global entity
};

export const entityConfig = {
  entityMetadata,
};
